import { AssertHomey } from '../../../../util/decorators';

export const devices = {
	namespaced: true,

	state: {
		devices: null,
		subscribed: false,
	},

	getters: {
		all(store){
			return store.devices;
		},
	},

	mutations: {
		setDevices(state, { devices, subscribe }){
			state.devices = devices;
			if(!state.subscribed) {
    			state.subscribed = true;
    			subscribe();
			}
		},
		clearAll(state){
			state.devices = null;
			state.subscribed = false;
		}
	},

	actions: {
		@AssertHomey()
		retrieveAll({ commit, homeyAPI }){
    		
    		let refresh;
    		
    		let subscribe = () => {
        		homeyAPI.devices.on('device.update', refresh);
        		homeyAPI.devices.on('device.create', refresh);
        		homeyAPI.devices.on('device.delete', refresh);
    		};
    		
    		refresh = async () => {
                let devices = await homeyAPI.devices.getDevices()
				commit('setDevices', { devices: Object.values(devices), subscribe });
    		};
    		
    		refresh();

		},
		clearAll({ commit }){
			commit('clearAll');
		},
		@AssertHomey()
		setCapabilityValue({ commit, homeyAPI }, {deviceId, capability, value}) {
    		homeyAPI.devices.setCapabilityValue({ deviceId: deviceId, capabilityId: capability, value })
		}
	},

	plugins: [
		// (store) => {
		//   cloudAPI.on('logout', () => store.commit('api/logOut'));
		//   cloudAPI.on('token', (token) => store.commit('api/setToken', { token }));
		//
		//   const { token } = store.state.api;
		//   if (token) {
		//     store.dispatch('api/logIn', { token });
		//   }
		// },
	],
};
